// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"375":"eager-p0-core-components","551":"eager-p1-core-slices"}[chunkId] + "." + {"375":"7106c77971fa7f8b584c","551":"56f8dfa4b72d78e1ccf4"}[chunkId] + ".css";
};